module.exports = __webpack_public_path__ + "img/history-link.6c34d6a7.png";